import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { mergeMap, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BeginTokenRefresh } from '../state/auth.actions';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
    constructor(private store: Store) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            mergeMap((evt) => {
                return of<HttpEvent<any>>(evt).pipe(
                    catchError((err, caught) => {
                        if (err.status === 403) {
                            this.store.dispatch(new BeginTokenRefresh());
                        }
                        return caught;
                    })
                );
            }),
        );
    }
}
